import type { FC } from 'react'

import { StyledText } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'

import type { NumberRecordType } from '../types'

type Props = {
  selectedNumbers: Map<string, NumberRecordType>
}

export const RecipientsList: FC<Props> = ({ selectedNumbers }) => (
  <div className="flex w-full flex-col lg:h-5/6 lg:w-1/5 lg:gap-3">
    <div className="mb-3 pt-3 font-bold md:mb-7">
      {selectedNumbers.size} <Translation id="Recipients" />{' '}
    </div>
    <div className="w-full grow overflow-y-auto">
      <div className="hidden lg:inline-block">
        <div className="flex flex-col">
          {/* We spread the map here because datatype Map does not have a .map function like Arrays */}
          {[...selectedNumbers].map(([fullNumber, item]) => {
            const { name, countryId, number } = item
            let numberL = number.toLowerCase()
            const countryString = countryId?.toString()?.toLowerCase() || ''

            return (
              <div key={fullNumber} className="flex flex-col rounded p-2">
                <div>
                  {countryString && <StyledText size="regular-plus">+{countryString} </StyledText>}
                  {numberL}
                </div>
                <span className="text-sm text-gray-400">{name}</span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  </div>
)
